import axios from "axios";

export const getServices = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get("/services", params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getService = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/services/${data?.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createService = async ({ create }: any) => {
	try {
		const res: any = await axios.post(`/services`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const updateService = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/services/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteService = async ({ data, update }: any) => {
	try {
		const res: any = await axios.delete(`/services/${data?.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const restoreService = async ({ id }: any) => {
	try {
		const res: any = await axios.post(`/services/${id}/restore`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const resyncService = async ({ data }: any) => {
	try {
		const res: any = await axios.post(`/services/${data?.id}/resync`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

// --- Client availability (Fibar install-only project) ---
// List the clients a service is restricted to. Empty array = available to all.
export const getServiceAvailability = async ({ data }: any) => {
	try {
		const res: any = await axios.get(`/services/${data?.id}/availability`);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

// Replace the full client allowlist for a service. clientIds: string[]
// (empty array clears -> available to all clients).
export const setServiceAvailability = async ({ data, clientIds }: any) => {
	try {
		const res: any = await axios.put(`/services/${data?.id}/availability`, { clientIds });
		return res?.data ? res.data : [];
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

// Remove a single client from a service's allowlist.
export const removeServiceAvailability = async ({ data, clientId }: any) => {
	try {
		const res: any = await axios.delete(`/services/${data?.id}/availability/${clientId}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
